<template>
    <b-modal
        id="view-permission-modal"
        ref="viewPermissionModal"
        title="View Permission"
        size="lg"
        hide-footer
        no-close-on-backdrop
        :visible="visible"
        @show="onShow"
    >
        <main-loader :loading="isLoading"></main-loader>
        <div class="modal-content-scroll" v-for="selectedRole in roleDetails" :key="selectedRole.id">
            <!-- Role Info -->
            <div class="role-info-compact mb-3 pb-3 border-bottom">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 class="mb-1">{{ selectedRole.name }}</h5>
                    </div>
                </div>
            </div>

            <!-- Stats -->
            <div class="row mb-3">
                <div class="col-6">
                    <div class="stat-box-compact">
                        <i class="fa fa-shield text-primary"></i>
                        <div>
                            <strong class="d-block">{{ selectedRole.totalpermission }}</strong>
                            <small class="text-muted">Permissions</small>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="stat-box-compact">
                    <i class="fa fa-users text-success"></i>
                    <div>
                        <strong class="d-block">{{ selectedRole.userCount }}</strong>
                        <small class="text-muted">Users</small>
                    </div>
                    </div>
                </div>
            </div>

            <!-- Permissions List -->
            <h6 class="mb-2 text-muted">All Permissions:</h6>
            <div class="permissions-scroll-list">
                <div
                    v-for="permission in selectedRole.permissions"
                    :key="typeof permission === 'string' ? permission : (permission.key || permission.id || JSON.stringify(permission))"
                    class="permission-item-compact"
                >
                    <i class="fa fa-check text-success mr-2"></i>
                    <span>{{ permission }}</span>
                </div>
            </div>

            <div v-if="selectedRole.totalpermission === 0" class="text-center py-4">
                <i class="fa fa-ban fa-2x text-muted mb-2"></i>
                <p class="text-muted mb-0">No permissions assigned</p>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <b-button
            variant="outline-secondary"
            size="lg"
            class="mr-3"
            @click="hideModal"
            >
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import {
  GET_ROLE_WISE_PERMISSION_LIST,
} from "../../../store/actions.type.js";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
export default {
  name: "ViewPermissionModal",
  components: {
    "main-loader": LoaderComponent,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    roleid: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      roleDetails: [],
      isLoading: false,
    };
  },
  watch: {
    roleid: {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined) {
          this.fetchRoleWisePermission();
        }
      },
      immediate: true,
    },
  },
  methods: {
    show() {
      this.$refs.viewPermissionModal.show();
    },
    hideModal() {
      this.$refs.viewPermissionModal.hide();
    },
    onShow() {
      // Always fetch latest data when modal is shown
      this.fetchRoleWisePermission();
    },

    async fetchRoleWisePermission() {
      this.isLoading = true;
      this.setLoading && this.setLoading(true);

      try {
        this.roleDetails = [];
        const response = await this.$store.dispatch(
          GET_ROLE_WISE_PERMISSION_LIST,
          this.roleid,
        );
        this.roleDetails = response.data.details.map((item) => ({
          id: item.id,
          name: item.name,
          userCount: item.userCount,
          totalpermission: item.totalpermission,
          permissions: item.permissions 
        }));
      } catch (error) {
        console.error("Error fetching permission:", error);
        this.$toast.error(
          error.response?.data?.message ||
            "Failed to fetch permission. Please try again.",
          { position: "top-right" },
        );
        this.items = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
        this.setLoading && this.setLoading(false);
      }
    },
   
  },
};
</script>
<style scoped>
/* Stats Compact */
.stat-box-compact {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.stat-box-compact i {
  font-size: 24px;
}

/* Permissions Scroll List */
.permissions-scroll-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px;
  background: #fafafa;
}

.permissions-scroll-list::-webkit-scrollbar {
  width: 6px;
}

.permissions-scroll-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.permissions-scroll-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.permissions-scroll-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.permission-item-compact {
  padding: 8px 10px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
}

.permission-item-compact:last-child {
  border-bottom: none;
}

.permission-item-compact:hover {
  background: #f8f9fa;
}
</style>
